var map = {
	"./cn/Auth/PolicyPage.vue": [
		58968,
		118,
		6373,
		9335
	],
	"./en/Auth/PolicyPage.vue": [
		65330,
		118,
		890,
		2588
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 47419;
module.exports = webpackAsyncContext;